export const Types = {
    SAVE_LIST_CATEGORY: 'SAVE_LIST_CATEGORY',
    SAVE_LIST_POST: 'SAVE_LIST_POST',
    SAVE_LIST_TAG: 'SAVE_LIST_TAG',
    SAVE_ALL_TAG: 'SAVE_ALL_TAG',
    SAVE_LIST_POST_CATEGORY: 'SAVE_LIST_POST_CATEGORY'
  }
  